import {mobile} from "../main_trytone";
import Swiper from "swiper";

const profil = {

    init() {
        this.initProfilePickers();
        this.initForm();
        this.initNAV();
    },
    initNAV() {
        if (mobile.state === true && $(".__mobile_compte_nav").length > 0) {

            const swiper_mobile_compte_nav = new Swiper(".__mobile_compte_nav", {
                slidesPerView: 'auto',
                spaceBetween: 10,
                freeMode: {
                    enabled: true,
                },
                watchOverflow: true,
                grabCursor: true,
            });

            const goToActiveMobileCompteNav = () => {
                const $nav = $(".__mobile_compte_nav");
                const $active = $nav.find("._activ").first();

                if (!$active.length) return;

                const $slide = $active.hasClass("swiper-slide")
                    ? $active
                    : $active.closest(".swiper-slide");

                if (!$slide.length) return;

                const index = $slide.index();

                if (index >= 0) {
                    swiper_mobile_compte_nav.slideTo(index, 0, false);
                }
            };

            requestAnimationFrame(() => {
                swiper_mobile_compte_nav.update();
                goToActiveMobileCompteNav();
            });

            setTimeout(() => {
                swiper_mobile_compte_nav.update();
                goToActiveMobileCompteNav();
            }, 300);
        }
    },
    initForm() {


        $(document).on('click', '._media_precedent', function () {
            $(".__choice").show();
            $(".block-hide").hide();
        });

        //_btn_choice
        $(document).on('click', '._btn_choice', function () {
            let choice = $(this).data("choice");
            $(".__choice").hide();
            $(".block-hide[data-choice=" + choice + "]").show();
            $(".block-hide[data-choice!=" + choice + "]").hide();
        });

        document.querySelectorAll('.toggle-password').forEach(btn => {
            btn.addEventListener('click', function () {
                const input = document.querySelector(this.dataset.target);

                if (input.type === "password") {
                    input.type = "text";
                   // this.textContent = '<i class="fa-solid fa-eye-slash"></i>'; // icône alternative
                } else {
                    input.type = "password";
                    //this.textContent = '<i class="fa-solid fa-eye"></i>';
                }
            });
        });


        const _this = this;
        const $form = $('#form_inscription_salle');

        // s'assure que le bouton est bien de type submit
        $('button[name="_btn"][value="_create_profil"]').attr('type', 'submit');

        // 1) CLIC sur le bouton
        $(document).on('click', 'button[name="_btn"][value="_create_profil"]', function () {
            const form = this.form || $(this).closest('form')[0];
            if (!form) return;

            if (form.checkValidity()) {
                _this.showWait(true, 'Création de profil en cours, merci de patienter…');
                // désactive APRÈS que le submit natif soit parti
                const $btn = $(this);
                setTimeout(() => {
                    $btn.prop('disabled', true).addClass('_is-loading').attr('aria-busy', 'true');
                }, 0);
            } else {
                // laisse le navigateur afficher les erreurs
                _this.hideWait();
            }
        });

        // 2) FALLBACK submit (ex: touche Entrée)
        $form.on('submit', function () {
            if (this.checkValidity()) {
                _this.showWait(true, 'Création de profil en cours, merci de patienter…');
                // ne désactive PAS ici (peut bloquer le submit)
            } else {
                _this.hideWait();
            }
        });

        // 3) Si un champ est invalide → ferme le modal (au cas où)
        $form.find('input,select,textarea').on('invalid', () => _this.hideWait());
    },
    showWait(on = true, text) {
        const $m = $('.__modal_wait');
        if (!$m.length) return;
        if (text) $m.find('.__msg_desc').text(text);
        $m.toggleClass('_show', !!on);
    },
    hideWait() {
        this.showWait(false);
    },
    initProfilePickers() {
        $('._picture_profil').each(function () {
            const $box = $(this);
            if ($box.data('picker-initialized')) return;

            const $btn = $box.find('._add_picture');
            const $form = $box.closest('form');

            let name = 'salle_thumb';
            if ($btn.hasClass('_groupe')) name = 'groupe_thumb';
            const selector = `input[type="file"][name="${name}"]`;

            let $file = $form.find(selector);
            if (!$file.length) {
                $file = $(`<input type="file" name="${name}" accept="image/*" hidden>`);
                $form.append($file);
            }


            // <img> pour un cover propre (si tu l’utilises)
            if (!$btn.find('._avatar').length) {
                $btn.append('<img class="_avatar" alt="" style="display:none;width:100%;height:100%;object-fit:cover;border-radius:50%;">');
            }
            const $img = $btn.find('._avatar');

            const $modalWait = $('.__modal_wait');
            // crée le <span> si absent et met le texte par défaut
            if ($modalWait.length && !$modalWait.find('._msg > span').length) {
                $modalWait.find('._msg').append('<span>Image en cours de téléchargement, merci de patienter…</span>');
            }

            // remplace ceci : const showWait = (on=true) => $('.__modal_wait')[on ? 'show' : 'hide']();
            // par ceci :
            const showWait = (on = true, text = 'Image en cours de téléchargement, merci de patienter…') => {
                const $m = $('.__modal_wait');
                if ($m.length) {
                    const $s = $m.find('._msg > span');
                    if ($s.length) $s.text(text);
                    else $m.find('._msg').append(`<span>${text}</span>`);
                    $m.toggleClass('_show', !!on);
                }
            };


            //const showWait = (on=true) => $('.__modal_wait')[on ? 'show' : 'hide']();

            const openDialog = () => $file.trigger('click');
            $box.on('click', '._add_picture, span', openDialog);
            $box.on('keydown', '._add_picture', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openDialog();
                }
            });

            const MAX = 3 * 1024 * 1024; // 2 Mo

            $file.on('change', function () {
                const f = this.files && this.files[0];
                if (!f) return; // l'utilisateur a annulé

                showWait(true);

                // validations
                if (!/^image\//.test(f.type)) {
                    showWait(false);
                    alert('Veuillez choisir une image.');
                    this.value = '';
                    return;
                }
                if (f.size > MAX) {
                    showWait(false);
                    alert('Image trop lourde (max 2 Mo).');
                    this.value = '';
                    return;
                }

                // Précharge l'image pour garantir l'affichage avant de retirer le loader
                const url = URL.createObjectURL(f);
                const pre = new Image();

                pre.onload = () => {
                    // Aperçu plein cercle (choisis l’une des 2 lignes)
                    // A) avec <img>
                    $img.attr('src', url).show();
                    // B) via background:
                    // $btn.css('background', `center / cover no-repeat url("${url}")`);

                    $btn.addClass('has-image');
                    URL.revokeObjectURL(url);
                    showWait(false);
                };

                pre.onerror = () => {
                    showWait(false);
                    alert("Impossible de lire cette image.");
                    this.value = '';
                };

                pre.src = url;
            });

            $box.data('picker-initialized', true);
        });
    }


};

export default profil;
